// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const ACCESS_TOKEN_KEY = 'remember_admin_access_token';
const REFRESH_TOKEN_KEY = 'remember_admin_refresh_token';

const getStorage = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.localStorage;
};

export const getAccessToken = () => {
  try {
    return getStorage()?.getItem(ACCESS_TOKEN_KEY) || '';
  } catch (_error) {
    return '';
  }
};

export const getRefreshToken = () => {
  try {
    return getStorage()?.getItem(REFRESH_TOKEN_KEY) || '';
  } catch (_error) {
    return '';
  }
};

export const saveAuthTokens = (payload: API.RefreshTokenReply | API.LoginReply) => {
  const storage = getStorage();
  if (!storage) {
    return;
  }
  if (payload.access_token) {
    storage.setItem(ACCESS_TOKEN_KEY, payload.access_token);
  }
  if (payload.refresh_token) {
    storage.setItem(REFRESH_TOKEN_KEY, payload.refresh_token);
  }
};

export const clearAuthTokens = () => {
  const storage = getStorage();
  if (!storage) {
    return;
  }
  storage.removeItem(ACCESS_TOKEN_KEY);
  storage.removeItem(REFRESH_TOKEN_KEY);
};

export const mapAdminToCurrentUser = (admin?: API.Admin): API.CurrentUser => {
  return {
    name: admin?.username || '',
    userid: admin?.id,
  };
};

const requestData = async <T>(url: string, options: { [key: string]: any }) => {
  const res = await request<API.ApiResponse<T>>(url, options);
  if (res.code !== 200) {
    throw new Error(res.message || '请求失败');
  }
  return res.data as T;
};

export async function uploadFile(file: File, type: number, options?: { [key: string]: any }) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type.toString());

  const res = await request<API.ApiResponse<{ url: string }>>('/admin/v1/upload/file', {
    method: 'POST',
    data: formData,
    ...(options || {}),
  });
  if (res.code !== 200) {
    throw new Error(res.message || '上传失败');
  }
  return res.data as { url: string };
}

export async function getAdminInfo(options?: { [key: string]: any }) {
  return requestData<API.GetAdminInfoReply>('/admin/v1/admin/info', {
    method: 'POST',
    data: {},
    ...(options || {}),
  });
}

export async function currentUser(options?: { [key: string]: any }) {
  const res = await getAdminInfo(options);
  return {
    data: mapAdminToCurrentUser(res.admin),
  };
}

export async function outLogin() {
  clearAuthTokens();
  return Promise.resolve({});
}

export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  const res = await requestData<API.LoginReply>('/admin/v1/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      username: body.username,
      password: body.password,
    },
    ...(options || {}),
  });
  saveAuthTokens(res);
  return res;
}

export async function refreshToken(body: API.RefreshTokenRequest, options?: { [key: string]: any }) {
  const res = await requestData<API.RefreshTokenReply>('/admin/v1/token/refresh', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
  saveAuthTokens(res);
  return res;
}

export async function listAppVersions(
  body: API.ListAppVersionsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListAppVersionsReply>('/admin/v1/app_versions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listVips(
  body: API.ListVipsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListVipsReply>('/admin/v1/vips', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listVipOrders(
  body: API.ListVipOrdersRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListVipOrdersReply>('/admin/v1/vip/orders', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listKeyDays(
  body: API.ListKeyDaysRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListKeyDaysReply>('/admin/v1/key_days', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listUsers(body: API.ListUsersRequest, options?: { [key: string]: any }) {
  return requestData<API.ListUsersReply>('/admin/v1/users', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function createUser(
  body: API.CreateUserRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.CreateUserReply>('/admin/v1/user/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function updateUser(body: API.UpdateUserRequest, options?: { [key: string]: any }) {
  return requestData<API.Empty>('/admin/v1/user/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getUserDetail(id: string, options?: { [key: string]: any }) {
  const res = await listUsers(
    {
      page: 1,
      page_size: 1,
      id,
    },
    options,
  );
  return (res.users || [])[0];
}

export async function getUserPhone(
  body: API.GetUserPhoneRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.GetUserPhoneReply>('/admin/v1/user/phone', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getUserRestrictions(
  body: API.GetUserRestrictionsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.GetUserRestrictionsReply>('/admin/v1/user/restrictions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function saveUserRestriction(
  body: API.SaveUserRestrictionRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/user/restriction/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listUserRestrictionLogs(
  body: API.ListUserRestrictionLogsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListUserRestrictionLogsReply>('/admin/v1/user/restriction/logs', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function exportSharedData(
  body: API.ExportSharedDataRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ExportSharedDataReply>('/admin/v1/shared_data/export', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listMoments(
  body: API.ListMomentsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListMomentsReply>('/admin/v1/moments', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listUserMomentTags(
  body: API.ListUserMomentTagsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListUserMomentTagsReply>('/admin/v1/user/moment/tags', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listUserRecordBitmaps(
  body: API.ListUserRecordBitmapsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListUserRecordBitmapsReply>('/admin/v1/user/record_bitmaps', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function markUserRecordBitmapDay(
  body: API.MarkUserRecordBitmapDayRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/user/record_bitmap/mark', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function updateMomentHotValue(
  body: API.UpdateMomentHotValueRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/moment/hot_value/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function updateMomentBaseHotValue(
  body: API.UpdateMomentBaseHotValueRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/moment/base_hot_value/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function updateMomentIsFeatured(
  body: API.UpdateMomentIsFeaturedRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/moment/is_featured/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function saveMoment(
  body: API.CreateMomentRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.CreateMomentReply>('/admin/v1/moment/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deleteMoment(
  body: { id?: string },
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/moment/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listComments(
  body: API.ListCommentsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListCommentsReply>('/admin/v1/comments', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listFeedbacks(
  body: API.ListFeedbacksRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListFeedbacksReply>('/admin/v1/feedbacks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deleteFeedback(
  body: API.DeleteFeedbackRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/feedback/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listMomentReports(
  body: API.ListMomentReportsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListMomentReportsReply>('/admin/v1/moment/reports', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listMomentComments(
  body: API.ListMomentCommentsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListMomentCommentsReply>('/admin/v1/moment/comments', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listMomentLikes(
  body: API.ListMomentLikesRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListMomentLikesReply>('/admin/v1/moment/likes', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listMomentCollectUsers(
  body: API.ListMomentCollectUsersRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListMomentCollectUsersReply>('/admin/v1/moment/collect_users', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listContentAudits(
  body: API.ListContentAuditsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListContentAuditsReply>('/admin/v1/content_audits', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getContentAudit(
  body: API.GetContentAuditRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.GetContentAuditReply>('/admin/v1/content_audit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listCities(body: API.ListCitiesRequest, options?: { [key: string]: any }) {
  return requestData<API.ListCitiesReply>('/admin/v1/cities', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

export async function listSysConfigs(
  body: API.ListSysConfigsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListSysConfigsReply>('/admin/v1/sys_configs', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

export async function saveSysConfig(
  body: API.SaveSysConfigRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.SaveSysConfigReply>('/admin/v1/sys_config/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function saveCity(body: API.SaveCityRequest, options?: { [key: string]: any }) {
  return requestData<API.SaveCityReply>('/admin/v1/city/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deleteCity(body: API.DeleteCityRequest, options?: { [key: string]: any }) {
  return requestData<API.Empty>('/admin/v1/city/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listTopics(body: API.ListTopicsRequest, options?: { [key: string]: any }) {
  return requestData<API.ListTopicsReply>('/admin/v1/topics', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

export async function saveTopic(body: API.SaveTopicRequest, options?: { [key: string]: any }) {
  return requestData<API.SaveTopicReply>('/admin/v1/topic/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deleteTopic(body: API.DeleteTopicRequest, options?: { [key: string]: any }) {
  return requestData<API.Empty>('/admin/v1/topic/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listFaqs(body: API.ListFaqsRequest, options?: { [key: string]: any }) {
  return requestData<API.ListFaqsReply>('/admin/v1/faqs', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

export async function saveFaq(body: API.SaveFaqRequest, options?: { [key: string]: any }) {
  return requestData<API.SaveFaqReply>('/admin/v1/faq/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deleteFaq(body: API.DeleteFaqRequest, options?: { [key: string]: any }) {
  return requestData<API.Empty>('/admin/v1/faq/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function saveAppVersion(
  body: API.SaveAppVersionRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.SaveAppVersionReply>('/admin/v1/app_version/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deleteAppVersion(
  body: API.DeleteAppVersionRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/app_version/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listAppPushTasks(
  body: API.ListAppPushTasksRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListAppPushTasksReply>('/admin/v1/app_push/tasks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function saveAppPushTask(
  body: API.SaveAppPushTaskRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.SaveAppPushTaskReply>('/admin/v1/app_push/task/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function cancelAppPushTask(
  body: API.CancelAppPushTaskRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/app_push/task/cancel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listOfficialMessages(
  body: API.ListOfficialMessagesRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListOfficialMessagesReply>('/admin/v1/official_messages', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function saveOfficialMessage(
  body: API.SaveOfficialMessageRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.SaveOfficialMessageReply>('/admin/v1/official_message/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deleteOfficialMessage(
  body: API.DeleteOfficialMessageRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/official_message/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listPopups(
  body: API.ListPopupsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListPopupsReply>('/admin/v1/popups', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function savePopup(
  body: API.SavePopupRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.SavePopupReply>('/admin/v1/popup/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deletePopup(
  body: API.DeletePopupRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/popup/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listMoods(
  body: API.ListMoodsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListMoodsReply>('/admin/v1/moods', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function saveMood(
  body: API.SaveMoodRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.SaveMoodReply>('/admin/v1/mood/save', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function deleteMood(
  body: API.DeleteMoodRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/mood/delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function listBadges(
  body: API.ListBadgesRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListBadgesReply>('/admin/v1/badges', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function saveBadge(
  body: API.SaveBadgeRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.SaveBadgeReply>('/admin/v1/badge/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deleteBadge(
  body: API.DeleteBadgeRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/badge/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function listAIAnalysisItems(
  body: API.ListAIAnalysisItemsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListAIAnalysisItemsReply>('/admin/v1/ai_analysis/items', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function saveAIAnalysisItem(
  body: API.SaveAIAnalysisItemRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.SaveAIAnalysisItemReply>(
    '/admin/v1/ai_analysis/item/save',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

export async function deleteAIAnalysisItem(
  body: API.DeleteAIAnalysisItemRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/ai_analysis/item/delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function listAIAnalysisQuestions(
  body: API.ListAIAnalysisQuestionsRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.ListAIAnalysisQuestionsReply>(
    '/admin/v1/ai_analysis/questions',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

export async function saveAIAnalysisQuestion(
  body: API.SaveAIAnalysisQuestionRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.SaveAIAnalysisQuestionReply>(
    '/admin/v1/ai_analysis/question/save',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

export async function deleteAIAnalysisQuestion(
  body: API.DeleteAIAnalysisQuestionRequest,
  options?: { [key: string]: any },
) {
  return requestData<API.Empty>('/admin/v1/ai_analysis/question/delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function rule(
  params: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
